// config/auth.js - Google OAuth client ID for the web popup sign-in.
export const GOOGLE_WEB_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID ||
  '899999320359-coe885kcaigtluiavtndbmc99ba5a816.apps.googleusercontent.com';
